<template>
  <div class="col-4" style="height: 380px; padding: 0px 5px">
    <div class="wrapper">
      <router-link
        :to="{ name: 'factsheet', params: { factsheet_id: item.identifier } }"
        v-bind:style="previewStyle"
      >
        <div class="badge" :style="badgeStyle">
          <span class="item-status item-ok" v-if="item.status == 0"
            ><i class="bi bi-clock"></i> Processing</span
          >
          <span class="" v-if="item.status == 1"><i style="float:right;color:rgba(255,255,255,0.8)" class="bi bi-check-circle-fill"></i></span>
          <span class="item-status item-error" v-if="item.status == 2"
            >Error</span
          >
          <span class="item-status item-ok" v-if="item.status == 3"
            ><i class="bi bi-clock"></i> Processing</span
          >
          <span class="item-status item-error" v-if="item.status == 4"
            >Expired</span
          >
          <span class="item-status item-error" v-if="item.status == 6"
            >Deleted</span
          >
          <span class="item-status item-error" v-if="item.status == 5"
            >Error</span
          >
          {{ item.factsheettype.title }}
        </div>
        <div class="item-header">
          <h5 class="title" v-if="item.location.name">
            {{ item.location.name }}
          </h5>
          <h5 class="title" v-else>{{ item.location.identifier }}</h5>
        </div>
      </router-link>
      <div class="item-footer">
        
        <div class="item-footer-content">
          <span
            ><i class="bi bi-geo-alt-fill" style="color: #888"></i>&nbsp;
            {{ item.location.size }} km<sup>2</sup> area
            {{ item.location.city_distance }} km
            {{ item.location.city_bearing.toUpperCase() }} of
            {{ item.location.city_near }}.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  data() {
    return {};
  },
  computed: {
    previewUrl() {
      if (this.item.preview_path) {
        return (
          process.env.VUE_APP_API +
          "/data/factsheet" +
          this.item.preview_path +
          "/PreviewOpenstreetmap.jpg"
        );
      } else {
        return "";
      }
    },
    previewStyle() {
      if (this.previewUrl) {
        if((this.item.status == 4) || (this.item.status == 5) || (this.item.status == 2) || (this.item.status == 6)) {
          return (
          "background-image:url(" +
          this.previewUrl +
          ");background-position:center center;background-size:cover;filter:grayscale(0.9);opacity:0.8;pointer-events:none;"
        );
        } else {
          return (
          "background-image:url(" +
          this.previewUrl +
          ");background-position:center center;background-size:cover;"
        );
        }
        
      } else {
        return "background-color:#eee;";
      }
    },
    badgeStyle() {
      let color =
        "color:#fff;background-color:" + this.item.factsheettype.color + ";";
      return (
        "font-size:1em;border:none;width:100%;text-align:left;border-radius:0px;padding:6px 6px;" +
        color
      );
    },
  },
  props: ["item"],
  components: {},
  name: "Item",
};
</script>

<style></style>

<style scoped>
h5 {
  font-size: 1.3em;
  font-weight: bold;
}
li {
  width: 33.3334%;
  float: left;
  margin: 0px;
  padding: 0px;
  margin-bottom: 10px;
  list-style-type: none;
}

div.wrapper {
  background-color: #f6f6f6;
}
span.item-status {
  font-size: 0.85em;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 2px 4px;
  border: none;
  border-radius: 2px;
  display: inline-block;
}
li:nth-child(odd) div.wrapper {
  //padding-right:4px;
}
li:nth-child(even) div.wrapper {
  //padding-left:4px;
}
div.wrapper a,
div.wrapper div.expired {
  display: inline-block;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  border: 0px solid #ccc;
}
li a:hover {
  //background-color:#f5f5f5;
}

div.item-header {
  background-color: rgba(255, 255, 255, 0.9);
  padding: 0px 0px;
  border-bottom: 1px solid #ccc;
}
li a:hover div.item-header {
  //background-color:#fff;
}
div.item-header h5 {
  padding: 10px 5px 10px 5px;
  margin: 0;
}
div.item-header h6 {
  padding: 0px 5px 2px 5px;
  color: #666;
  font-weight: bold;
  font-size: 0.9em;
}
div.item-preview {
  width: 100%;
  height: 0;
  padding-bottom: 50%;
  display: block;
  position: relative;
  bottom: 10px;
  background-color: red;
}
div.item-footer {
  position: relative;
  min-height: 200px;
  font-size: 0.9em;
  color: #666;
  pointer-events: none;
  margin-top: -200px;
}
div.item-footer div.item-footer-content {
  position: absolute;
  bottom: 3px;
  left: 0;
}
div.item-footer div.item-footer-world {
  width: 90px;
  height: 45px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 100px;
  position: absolute;
  bottom: 3px;
  right: 3px;
}
div.item-footer div.item-footer-content span {
  clear: left;
  margin-bottom: 3px;
  margin-left: 3px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 2px;
  padding: 1px 3px;
  color: #666;
}
div.item-footer div.location {
  display: inline;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  padding: 3px 5px;
  color: #fff;
}
div.item-footer div.size {
  padding-right: 5px;
  padding-top: 4px;
}
span.item-error {
  float: right;
  color: red;
}
span.item-ok {
  float: right;
  color: green;
}
span.item-empty {
  float: right;
  background-color:none;

}
</style>
